module.exports = __webpack_public_path__ + "img/1485832335.019f6aa6.jpg";